import { SET_VEHICLEBYTYPE } from '../actions';

const vechiclebytype = (state = [], action) => {
  switch (action.type) {
	case SET_VEHICLEBYTYPE:
      return [...action.value];  
    default: return state;
  }
}

export default vechiclebytype;
